import React, { useState } from "react"
import sortBy from "utils/sortBy"

import Grid from "components/grid"
import VideoCard from "components/card/video"
import FilterSort from "./filter-sort"

const RevitalizeVideosGrid = ({ allVideos, selectedVideo }) => {
  const [filteredVideos, setFilteredVideos] = useState(sortBy(allVideos, "airDate").reverse())

  return (
    <Grid
      title={selectedVideo ? "Videos" : ""}
      numColumns={{ default: 3, desktopL: 3, desktop: 2, tablet: 2, mobile: 1 }}
      rowMargin="2.2rem"
      colMargin="2.2rem"
      filterSort={<FilterSort allVideos={allVideos} setFilteredVideos={setFilteredVideos} />}
    >
      {filteredVideos.map((video, idx) => (
        <VideoCard
          key={video.id}
          headline={video.title}
          speakers={video.speakers}
          lengthInSeconds={video.lengthInSeconds}
          link={`/revitalize/videos/${video.url}`}
          localLink
          imageUrl={video.image}
          lazyLoadImage={idx >= 9}
          isGrid
        />
      ))}
    </Grid>
  )
}

export default RevitalizeVideosGrid
